import { BindActivityInfo } from "@/components/top-up/types";
import { ActivityTypeCode } from "project-config/constants";
import { useLayoutEffect, useState } from "react";
import { useQuery } from "react-query";

export const useFetchPicActivity = () => {
  const { data, refetch } = useQuery<BindActivityInfo[]>(
    "/api/rendering/user/activity/template/getSupportActivity"
  );
  const [memberActivityList, setMemberActivityList] =
    useState<BindActivityInfo[]>();
  const [rechargeActivityList, setRechargeActivityList] =
    useState<BindActivityInfo[]>();
  useLayoutEffect(() => {
    if (!data) {
      setMemberActivityList([]);
      setRechargeActivityList([]);
      return;
    }
    // 购买会员送会员
    setMemberActivityList(
      data.filter(
        (item) =>
          item.activityType === ActivityTypeCode.GiftMember &&
          item.activityDetail[0].vipAmount
      )
    );
    // 充值赠送活动
    setRechargeActivityList(
      data.filter((item) => item.activityType === ActivityTypeCode.RechargeGift)
    );
  }, [data]);

  return {
    memberActivityList,
    rechargeActivityList,
    clientActivityInfoListRefetch: refetch,
  };
};
